/**
* This component will show the booking info and calculated total price.
* I.e. dates and other details related to payment decision in receipt format.
*/
import classNames from 'classnames';
import { bool, oneOf, string } from 'prop-types';
import React, { memo } from 'react';
import { injectIntl, intlShape } from '../../util/reactIntl';
import {
 LINE_ITEM_CUSTOM_REFUND,
 LINE_ITEM_CUSTOMER_COMMISSION,
 LINE_ITEM_PROCESSING_FEE,
 LINE_ITEM_UNITS,
 propTypes,
} from '../../util/types';
import css from './BookingBreakdownNew.css';


import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import LineItemCreditsMaybe from './LineItemCreditsMaybe';
import LineItemCustomerCommissionMaybe from './LineItemCustomerCommissionMaybe';
import LineItemCustomerCommissionRefundMaybe from './LineItemCustomerCommissionRefundMaybe';
import LineItemFuelInclusionAddOnMaybe from './LineItemFuelInclusionAddOnMaybe';
import LineItemLongTermDiscountMaybe from './LineItemLongTermDiscountMaybe';
import LineItemMasterCardPromoMaybe from './LineItemMastercardPromoMaybe';
import LineItemNewCarDiscountMaybe from './LineItemNewCarDiscountMaybe';
import LineItemNewExcessReduction from './LineItemNewExcessReduction';
import LineItemNewExcessReduction2 from './LineItemNewExcessReduction2';
import LineItemNewHomeDeliveryAddOnMaybe from './LineItemNewHomeDeliveryAddOnMaybe';
import LineItemNewMileagePackage from './LineItemNewMileagePackage';
import LineItemNewMileagePackageRefundMaybe from './LineItemNewMileagePackageRefundMaybe';
import LineItemProcessingFee from './LineItemProcessingFee';
import LineItemProcessingFeeRefundMaybe from './LineItemProcessingFeeRefundMaybe';
import LineItemPromotionDiscountMaybe from './LineItemPromotionDiscountMaybe';
import LineItemProviderCommissionMaybe from './LineItemProviderCommissionMaybe';
import LineItemProviderCommissionRefundMaybe from './LineItemProviderCommissionRefundMaybe';
import LineItemTotalPrice from './LineItemTotalPrice';
import LineItemUnknownItemsMaybe from './LineItemUnknownItemsMaybe';
import LineItemUnknownItemsRefundMaybe from './LineItemUnknownItemsRefundMaybe';
import LineItemUpdateBookingMaybe from './LineItemUpdateBookingMaybe';
import LineItemYoungCustomerCommissionMaybe from './LineItemYoungCustomerCommissionMaybe';
import LineItemYoungCustomerCommissionMaybeRefund
 from './LineItemYoungCustomerCommissionRefundMaybe';


import LineItemProviderDeductionsMaybe from './LineItemProviderDeductionsMaybe';
import LineItemProviderDeductionsRefundMaybe from './LineItemProviderDeductionsRefundMaybe';
import LineItemPremiumProcessingFeeDiscount from './LineItemPremiumProcessingFeeDiscount';
import TripExtensionModficationPeriod from '../TripModificationPeriod/TripExtensionModficationPeriod';
import ModificationAndExtensionCharges from '../ModificationCharges/ModificationAndExtenstionCharges';
import { restoreTransaction } from '../../util/data';


export const BookingBreakdownNewComponent = memo(
 props => {
   const {
     parentTx,
     lastUpdateBookingTx,
     rootClassName,
     className,
     intl,
     userRole,
     transaction: rawTransaction,
     currentUser,
     doNotShowTotal,
     unitType,
     isOnListingPage = false,
     timeZone,
     hideBookingPeriod,
     checkoutStep,
     changeCheckoutStep,
     isAddons,
     isTripDetailsPage,
     totalAllTransactions,
     providerFeeAllTransactions,
     replaceTotal,
     replaceTotalText,
     isFuelInclusion,
     fuelPrice,
     isCheckoutPage,
     otherCharges,
     isTripExtension,
     isListingPriceIncreased,
     parentTransactionId,
     history,
     openInvoices,
   } = props;


   console.log("Totoal Addone data", props);
   const isCustomer = userRole === 'customer';
   const isProvider = userRole === 'provider';
   const classes = classNames(rootClassName || css.root, className);
   let transaction = rawTransaction;


   const lastAcceptedTx = isCheckoutPage &&
     rawTransaction &&
     rawTransaction.attributes.protectedData.initialTx && {
       id: 'restored-tx-id',
       attributes: {
         ...rawTransaction.attributes.protectedData.initialTx.attributes,
         lineItems: JSON.parse(
           rawTransaction.attributes.protectedData.initialTx.attributes.lineItems
         ),
       },
     };


   let initialTransaction = restoreTransaction(
     lastAcceptedTx
       ? {
         ...lastAcceptedTx,
         listing: transaction.listing,
       }
       : null
   );
   console.log("Initial Transaction", initialTransaction);


   // const LTM_MONTHLY_PRICE = 300000;
   // if (isLongTermRental) {
   //   transaction = changeLTMPrice(transaction, LTM_MONTHLY_PRICE);
   // }
   return (
     <div className={classes}>
       {/* {isOnListingPage || hideBookingPeriod ? null
       : (<LineItemBookingPeriod
           booking={transaction.booking}
           unitType={unitType}
           timezone={timeZone}
         />
       )} */}


       {isAddons ? (
         <>
           <LineItemProcessingFeeRefundMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             isAddons={isAddons}
           />
         </>
       ) : (
         <>
           {initialTransaction && (
             <>
               <TripExtensionModficationPeriod
                 transaction={transaction}
                 isTripExtension={isTripExtension}
                 history={history}
                 parentTransactionId={parentTransactionId}
               />
               <ModificationAndExtensionCharges
                 intl={intl}
                 transaction={transaction}
                 isTripExtension={isTripExtension}
                 isCustomer={isCustomer}
                 isProvider={isProvider}
                 unitType={unitType}
                 isListingPriceIncreased={isListingPriceIncreased}
               />
             </>
           )}
           {!initialTransaction && (
            <>
           <LineItemUnknownItemsMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             isProvider={isProvider}
           />
           <LineItemUnknownItemsRefundMaybe
             transaction={transaction}
             intl={intl}
             isProvider={isProvider}
             isCustomer={isCustomer}
           />
            </>
           )}

           <LineItemProviderDeductionsMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
           />
           <LineItemProviderDeductionsRefundMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
           />
           {!initialTransaction && (
           <LineItemCustomerCommissionMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             isTripDetailsPage={isTripDetailsPage}
           />
           )}
           <LineItemCustomerCommissionRefundMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
           />
           <LineItemYoungCustomerCommissionMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             isTripDetailsPage={isTripDetailsPage}
           />
           <LineItemYoungCustomerCommissionMaybeRefund
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
           />
           {!initialTransaction && (
           <LineItemProcessingFee transaction={transaction} isCustomer={isCustomer} intl={intl} />
           )}
           <LineItemProcessingFeeRefundMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             isTripDetailsPage={isTripDetailsPage}
             otherCharges={otherCharges}
           />


           <LineItemProviderCommissionMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
             isTripDetailsPage={isTripDetailsPage}
             providerFeeAllTransactions={providerFeeAllTransactions}
             parentTx={parentTx}
           />
           <LineItemProviderCommissionRefundMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
           />
           {isTripDetailsPage ? null : (
             <LineItemUpdateBookingMaybe
               isProvider={isProvider}
               lastUpdateBookingTx={lastUpdateBookingTx}
               intl={intl}
             />
           )}
         </>
       )}


       {doNotShowTotal || (!isTripDetailsPage && initialTransaction) ? null : (
         <div>
           <LineItemNewExcessReduction
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             unitType={unitType}
             isTripDetailsPage={isTripDetailsPage}
           />
           <LineItemNewExcessReduction2
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             unitType={unitType}
             isTripDetailsPage={isTripDetailsPage}
           />
           <LineItemPremiumProcessingFeeDiscount
            transaction={transaction}
            isCustomer={isCustomer}
            intl={intl}
          />
           <LineItemMasterCardPromoMaybe
             transaction={transaction}
             userRole={userRole}
             intl={intl}
           />
           <LineItemLongTermDiscountMaybe transaction={transaction} intl={intl} />
           <LineItemCreditsMaybe transaction={transaction} isProvider={isProvider} intl={intl} />
           <LineItemPromotionDiscountMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
           />
           <LineItemNewCarDiscountMaybe
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
           />
           <LineItemNewHomeDeliveryAddOnMaybe
             transaction={transaction}
             isProvider={isProvider}
             isCustomer={isCustomer}
             intl={intl}
           />
           <LineItemNewMileagePackage
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             unitType={unitType}
           />
           <LineItemNewMileagePackageRefundMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
             unitType={unitType}
           />
           <LineItemFuelInclusionAddOnMaybe isShow={isFuelInclusion} fuelPrice={fuelPrice} />
           {/*<LineItemNewFuelInclusionAddOnMaybe
             transaction={transaction}
             isCustomer={isCustomer}
             intl={intl}
           /> */}
           {isAddons ? (
             <LineItemProcessingFee
               transaction={transaction}
               isCustomer={isCustomer}
               intl={intl}
               isAddons={isAddons}
             />
           ) : null}
           {/* {isAddons ? (
             <LineItemProcessingFeeRefundMaybe
               transaction={transaction}
               isCustomer={isCustomer}
               intl={intl}
               isAddons={isAddons}
             />
           ) : null} */}
           {/* {isAddons ? (
             <LineItemPremiumProcessingFeeDiscount
               transaction={transaction}
               isCustomer={isCustomer}
               intl={intl} />
           ) : null} */}
           <hr className={css.totalDivider} />
           <LineItemTotalPrice
             parentTx={parentTx}
             currentUser={currentUser}
             transaction={transaction}
             isProvider={isProvider}
             intl={intl}
             isAddons={isAddons}
             isTripDetailsPage={isTripDetailsPage}
             totalAllTransactions={totalAllTransactions}
             replaceTotalText={replaceTotalText}
             replaceTotal={replaceTotal}
             openInvoices={openInvoices}
           />
           {/* {checkoutStep === checkoutStepConfiguration.CHECKOUT_PAYMENT && (
             <div
               className={css.editAddOns}
               onClick={() => changeCheckoutStep(checkoutStepConfiguration.CHECKOUT_ADD_ONS)}
             >
               <span>
                 <img src={editIcon} alt="" />
               </span>
               Edit Add-ons
             </div>
           )} */}
         </div>
       )}
     </div>
   );
 },
 (prev, next) =>
   isEqual(
     pick(prev, ['userRole', 'transaction', 'currentUser', 'checkoutStep', 'isFuelInclusion', 'parentTx']),
     pick(next, ['userRole', 'transaction', 'currentUser', 'checkoutStep', 'isFuelInclusion', 'parentTx'])
   )
);


BookingBreakdownNewComponent.defaultProps = {
 rootClassName: null,
 className: null,
 doNotShowTotal: false,
 customRefundType: LINE_ITEM_CUSTOM_REFUND,
 hideUnitPrice: false,
 timeZone: 'Asia/Singapore',
};


BookingBreakdownNewComponent.propTypes = {
 rootClassName: string,
 className: string,
 transactionMode: bool,
 userRole: oneOf(['customer', 'provider']).isRequired,
 unitType: propTypes.bookingUnitType.isRequired,
 transaction: propTypes.transaction.isRequired,
 booking: propTypes.booking.isRequired,
 doNotShowTotal: bool,
 hideUnitPrice: bool,
 // from injectIntl
 intl: intlShape.isRequired,
 isFuelInclusion: bool,
};


const BookingBreakdownNew = injectIntl(BookingBreakdownNewComponent);


BookingBreakdownNew.displayName = 'BookingBreakdownNew';


export default BookingBreakdownNew;


const changeLTMPrice = (rawTransaction, LTM_MONTHLY_PRICE) => {
 let transaction = cloneDeep(rawTransaction);
 const lineItems =
   (transaction && transaction.attributes && transaction.attributes.lineItems) || [];
 let longTermRentalPrice, processFees, tripFees;
 let totalPrice = transaction.attributes.payinTotal;
 lineItems.forEach(lineItem => {
   if (lineItem.code === LINE_ITEM_UNITS) {
     longTermRentalPrice = lineItem.lineTotal;
   } else if (lineItem.code === LINE_ITEM_PROCESSING_FEE) {
     processFees = lineItem.lineTotal;
   } else if (lineItem.code === LINE_ITEM_CUSTOMER_COMMISSION) {
     tripFees = lineItem.lineTotal;
   }
 });
 longTermRentalPrice.amount = LTM_MONTHLY_PRICE;
 processFees.amount = (LTM_MONTHLY_PRICE + tripFees.amount) * 0.04;
 totalPrice.amount = LTM_MONTHLY_PRICE + processFees.amount + tripFees.amount;
 return transaction;
};  